const prefix = 'hzw_rq_new_sign'
/**@enum {string} */
export const STORAGENAME_RQ = {
  DUE: prefix + 'due',
  TEL: prefix + 'tel',
  REMARK: prefix + 'remark'
}
